module.exports = __webpack_public_path__ + "media/customizations/somersett/logo-ddae23ea8dd89f273b7fdfeaa506fdc1.png";